<template>
    <div class="notification-admin container">
        <heading title="System-wide Notifications"/>
        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getItems"
                    v-model="filters"
                    :fields="fields">
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'message'">
                    <span v-html="truncate(slotProps.row.item.message)"/>
                </div>
                <div v-else-if="slotProps.row.field.key === 'created'">
                    <timestamp :date="slotProps.row.item.created"/>
                </div>
                <div v-else-if="slotProps.row.field.key === 'user'">
                    <router-link
                        v-if="slotProps.row.item.user"
                        :to="`/user/view/${slotProps.row.item.user.id}`">
                        {{slotProps.row.item.user.full_name}}
                    </router-link>
                </div>
                <div v-else-if="slotProps.row.field.key === 'project'">
                    <router-link
                        v-if="slotProps.row.item.project"
                        :to="`/project/view/${slotProps.row.item.project.id}`">
                        {{slotProps.row.item.project.name}}
                    </router-link>
                </div>
                <div v-else-if="slotProps.row.field.key === 'equipment'">
                    <router-link
                        v-if="slotProps.row.item.equipment"
                        :to="`/equipment/view/${slotProps.row.item.equipment.id}`">
                        {{slotProps.row.item.equipment.name}}
                    </router-link>
                </div>
                <div v-else-if="slotProps.row.field.key === 'actions'">
                    <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                            @click="viewNotification(slotProps.row.item)">
                        <b-icon-eye/>
                    </button>
                </div>
            </template>
        </data-table>

        <notification-view-modal
            :notification="notification"
            modalId="viewNotificationModal"/>
    </div>
</template>

<script>
export default {
    name: 'NotificationAdmin',
    data () {
        return {
            fields: [
                { key: 'user', label: 'User' },
                { key: 'project', label: 'Project' },
                { key: 'equipment', label: 'Equipment' },
                { key: 'message', label: 'Message' },
                { key: 'status', sortable: true, label: 'Read' },
                { key: 'created', sortable: true, label: 'Received' },
                { key: 'actions' },
            ],
            filters: {
                message: { field: 'message', type: 'string', value: null, label: 'Message' },
                status: { field: 'status', type: 'select', options: ['READ', 'UNREAD'], label: 'Read' },
                user_id: {
                    field: 'user_id',
                    type: 'multiselect',
                    search: (query) => {
                        return this.$api.getItems(this, 'user', { full_name: { field: 'full_name', value: query}})
                    },
                    label: 'User',
                    apiTable: 'user',
                    labelField: 'full_name'
                },
                project_id: {
                    field: 'project_id',
                    type: 'multiselect',
                    search: (query) => {
                        return this.$api.getItems(this, 'project', { name: { field: 'name', value: query}})
                    },
                    label: 'Project',
                    apiTable: 'project',
                    labelField: 'name'
                },
                equipment_id: {
                    field: 'equipment_id',
                    type: 'multiselect',
                    search: (query) => {
                        return this.$api.getItems(this, 'equipment', { vehicleString: { field: 'vehicleString', value: query}})
                    },
                    label: 'Equipment',
                    apiTable: 'equipment',
                    labelField: 'vehicleString'
                },
            },
            notification: {}
        }
    },
    methods: {
        async getItems (sort) {
            return await this.$api.getItems(this, 'notification', this.filters, sort, ['equipment'])
        },
        truncate (str, length = 128, end = '...') {
            return str.length > length ? str.substring(0, length - end.length) + end : str
        },
        async viewNotification (notification) {
            this.$bvModal.show('viewNotificationModal')
            this.notification = notification
        },
    }

}
</script>

<style scoped>

</style>